import moment from "moment";
import async from "async";

export const entity = {
    name: "DelayUpdate",
    fields: [
        {path: "code"},
        {path: "delay", type: "integer"},
        {path: "date", type: "date", nullable: true},
        {path: 'user', type: 'User', nullable: true}
    ],
    beforeSave: async (newObject, oldObject, context, callback) => {
        newObject.date = moment().format('YYYY-MM-DD HH:mm:ss')
        newObject.user = context.user
        try {
            await Promise.all([
                global.app.S.AlertConfiguration.collection.updateMany({}, {$set: {delay: newObject.delay}}),
                global.app.S.ScoringConfig.collection.updateMany({}, {$set: {delay: newObject.delay}})
            ]);
            callback(null, newObject, oldObject);
        } catch (e) {
            callback(e);
        }
    }
}

export const module_ = {
    object: "DelayUpdate",
    tKey: "mTitle_delayUpdate",
    updatable: false,
    category: {
        path: "setting",
        icon: "settings"
    },
    defaultSortBy: "date",
    defaultSortDirection: "DESC",
    viewMap: {
        dt: [
            {path: "date"},
            {path: "user"},
            {path: "code"},
            {path: "delay"},
        ],
        form: [
            {path: "code"},
            {path: "delay"}
        ]
    }
}
